/**
 * HairVirginity Pre-order cart safety net (cart / checkout only).
 * Does NOT touch PDP button/message — theme.js owns that.
 */
(function () {
  'use strict';

  var PREORDER_VALUE = 'Pre-order Item';
  var PREORDER_NOTE_KEY = 'Pre-order';
  var PREORDER_NOTE_VALUE = 'Custom item. Delivery in 3–12 working days.';
  var CUSTOM_KEY = 'CUSTOM';

  // * Charity donation (Easy Donation) — never treat as pre-order.
  // * Keep in sync with app_Laravel ShopifyService::DONATION_PRODUCT_ID / app_react constants.js
  var DONATION_PRODUCT_ID = 15374752448898;
  var DONATION_HANDLE = 'the-little-princess-trust-charity-donation';
  var DONATION_SKU_PREFIX = 'EDONATION-';
  var DONATION_VENDOR = 'zestard-easy-donation';

  var syncing = false;
  var activeSync = null;
  var variantCache = {};

  function inventoryQty(variant) {
    if (!variant) return null;
    if (variant.inventory_quantity === null || variant.inventory_quantity === undefined || variant.inventory_quantity === '') {
      return null;
    }
    var n = Number(variant.inventory_quantity);
    return isNaN(n) ? null : n;
  }

  /**
   * Donation line items must never receive CUSTOM / Pre-order properties.
   * Easy Donation variants often show inventory_quantity <= 0 with policy "continue",
   * which would otherwise be mis-detected as pre-order.
   */
  function isDonationItem(item) {
    if (!item) return false;
    if (Number(item.product_id) === DONATION_PRODUCT_ID) return true;
    if (item.handle === DONATION_HANDLE) return true;
    if (item.vendor === DONATION_VENDOR) return true;
    if (item.sku && String(item.sku).indexOf(DONATION_SKU_PREFIX) === 0) return true;
    return false;
  }

  function isPreOrder(variant, quantity) {
    if (!variant) return false;
    if (variant.inventory_policy !== 'continue') return false;
    var managed = variant.inventory_management;
    if (managed === null || managed === '') {
      if (inventoryQty(variant) === null) return false;
    } else if (!managed) {
      return false;
    }
    var stock = inventoryQty(variant);
    if (stock === null) return false;
    var qty = parseInt(quantity, 10) || 1;
    return stock <= 0 || qty > stock;
  }

  function cleanProperties(properties) {
    var next = {};
    if (!properties) return next;
    Object.keys(properties).forEach(function (key) {
      var val = properties[key];
      if (val === null || val === undefined || val === '') return;
      next[key] = val;
    });
    return next;
  }

  function hasPreOrderProperty(properties) {
    if (!properties) return false;
    if (properties[CUSTOM_KEY] === PREORDER_VALUE) return true;
    if (properties[PREORDER_NOTE_KEY]) return true;
    return false;
  }

  function applyPreOrderProperties(properties, enable) {
    var next = cleanProperties(properties);
    if (enable) {
      next[CUSTOM_KEY] = PREORDER_VALUE;
      next[PREORDER_NOTE_KEY] = PREORDER_NOTE_VALUE;
    } else {
      delete next[CUSTOM_KEY];
      delete next[PREORDER_NOTE_KEY];
    }
    return next;
  }

  function propertiesNeedUpdate(current, enable) {
    var hasCustom = current && current[CUSTOM_KEY] === PREORDER_VALUE;
    var hasNote = current && current[PREORDER_NOTE_KEY] === PREORDER_NOTE_VALUE;
    if (enable) return !hasCustom || !hasNote;
    return !!(hasCustom || (current && current[PREORDER_NOTE_KEY]));
  }

  async function fetchVariant(handle, variantId) {
    if (!handle || !variantId) return null;
    var cacheKey = handle + ':' + variantId;
    if (variantCache[cacheKey]) return variantCache[cacheKey];
    try {
      var productData = await fetch('/products/' + handle + '.js').then(function (r) {
        return r.json();
      });
      var variant = (productData.variants || []).find(function (v) {
        return v.id === variantId || String(v.id) === String(variantId);
      });
      if (variant) variantCache[cacheKey] = variant;
      return variant || null;
    } catch (e) {
      return null;
    }
  }

  async function updateLineProperties(itemKey, quantity, properties) {
    var response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: itemKey,
        quantity: quantity,
        properties: properties
      })
    });
    if (!response.ok) {
      throw new Error(await response.text());
    }
    return response.json();
  }

  function createPreOrderMessageEl(extraClass) {
    var msg = document.createElement('div');
    msg.className = 'hv-preorder-message pre-order-message' + (extraClass ? ' ' + extraClass : '');
    msg.setAttribute('role', 'status');
    msg.style.cssText = 'margin-top:6px;font-size:12px;line-height:1.4;';
    msg.innerHTML =
      '<strong style="color:#c9a368;">Pre-order:</strong> Custom item. Delivery in 3–12 working days.';
    return msg;
  }

  function paintCartMessages(preOrderKeys) {
    var keySet = {};
    (preOrderKeys || []).forEach(function (k) {
      keySet[k] = true;
    });

    document.querySelectorAll('.cart__item[data-key]').forEach(function (el) {
      var key = el.getAttribute('data-key');
      var details = el.querySelector('.cart__item-title') || el;
      var msg = el.querySelector('.pre-order-message');
      var shouldShow = !!keySet[key];

      if (shouldShow) {
        if (!msg) {
          msg = createPreOrderMessageEl('cart__item--preorder');
          details.appendChild(msg);
        }
      } else if (msg) {
        msg.remove();
      }
    });
  }

  function variantIdFromHref(href) {
    if (!href) return null;
    var match = String(href).match(/[?&]variant=(\d+)/);
    return match ? match[1] : null;
  }

  function handleFromHref(href) {
    if (!href) return null;
    var match = String(href).match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : null;
  }

  function paintReelUpCartMessages(preOrderVariantIds) {
    var idSet = {};
    (preOrderVariantIds || []).forEach(function (id) {
      if (id != null) idSet[String(id)] = true;
    });

    document.querySelectorAll('.reelUp_popup_cart_product').forEach(function (el) {
      var link = el.querySelector('.reelUp_popup_cart_product_title a');
      var variantId = variantIdFromHref(link && (link.getAttribute('href') || link.href));
      var shouldShow = !!(variantId && idSet[variantId]);
      var details =
        el.querySelector('.reelUp_popup_cart_product_info') ||
        el.querySelector('.reelUp_popup_cart_product_details') ||
        el;
      var msg = el.querySelector('.hv-preorder-message');

      if (shouldShow) {
        if (!msg) {
          msg = createPreOrderMessageEl('hv-reelup-cart-preorder');
          var opts = details.querySelector('.reelUp_popup_cart_options_outer');
          if (opts && opts.parentNode) {
            opts.parentNode.insertBefore(msg, opts.nextSibling);
          } else {
            details.appendChild(msg);
          }
        }
      } else if (msg) {
        msg.remove();
      }
    });
  }

  function getReelUpFormContext() {
    var form = document.querySelector('.reelup_modal_product_form');
    if (!form) return null;

    var idInput = form.querySelector('input[name="id"]');
    var qtyInput = form.querySelector('input.quantity_count, input[name="quantity"]');
    var variantId = idInput && idInput.value;
    var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

    var root =
      form.closest('.reelUp_modal_product_section') ||
      form.closest('.reelUp_modal_product') ||
      form;
    var link = root.querySelector('a[href*="/products/"]');
    var handle = handleFromHref(link && (link.getAttribute('href') || link.href));
    if (!handle && window.location.pathname.indexOf('/products/') === 0) {
      handle = window.location.pathname.split('/products/')[1].split(/[/?#]/)[0];
    }

    return { form: form, variantId: variantId, qty: qty, handle: handle, root: root };
  }

  function paintReelUpAtc(enable) {
    var btnText = document.querySelector('.reelUp_modal_atc_btn .reelUp_custom_btn_text');
    if (btnText) {
      if (!btnText.getAttribute('data-hv-default-text')) {
        btnText.setAttribute('data-hv-default-text', (btnText.textContent || 'Add to cart').trim());
      }
      btnText.textContent = enable
        ? 'PRE-ORDER'
        : btnText.getAttribute('data-hv-default-text');
    }

    var ctx = getReelUpFormContext();
    var info =
      (ctx && ctx.root.querySelector('.reelUp_modal_product_info')) ||
      document.querySelector('.reelUp_modal_product_info');
    if (!info) return;

    var msg = info.querySelector('.hv-preorder-message');
    if (enable) {
      if (!msg) {
        msg = createPreOrderMessageEl('hv-reelup-form-preorder');
        var after =
          info.querySelector('.reelUp_modal_prices') ||
          info.querySelector('.reelUp_modal_product_title') ||
          info.querySelector('.reelUp_variants_container');
        if (after && after.parentNode) {
          after.parentNode.insertBefore(msg, after.nextSibling);
        } else {
          info.appendChild(msg);
        }
      }
    } else if (msg) {
      msg.remove();
    }
  }

  var reelUpFormRefreshSeq = 0;

  async function resolveHandleForVariant(variantId) {
    if (!variantId) return null;

    if (window.location.pathname.indexOf('/products/') === 0) {
      var pageHandle = window.location.pathname.split('/products/')[1].split(/[/?#]/)[0];
      var pageVariant = await fetchVariant(pageHandle, variantId);
      if (pageVariant) return pageHandle;
    }

    var catalog = (window.REELUP && window.REELUP.products) || [];
    for (var i = 0; i < catalog.length; i++) {
      var handle = catalog[i] && catalog[i].handle;
      if (!handle) continue;
      var found = await fetchVariant(handle, variantId);
      if (found) return handle;
    }

    return null;
  }

  async function refreshReelUpProductForm() {
    var ctx = getReelUpFormContext();
    if (!ctx || !ctx.variantId) {
      return;
    }

    var seq = ++reelUpFormRefreshSeq;
    var handle = ctx.handle || (await resolveHandleForVariant(ctx.variantId));
    if (seq !== reelUpFormRefreshSeq) return;
    if (!handle) {
      return;
    }

    var variant = await fetchVariant(handle, ctx.variantId);
    if (seq !== reelUpFormRefreshSeq) return;

    var cartQty = 0;
    var cartItems = window.__hvLastCartItems;
    if (cartItems && cartItems.length) {
      cartItems.forEach(function (item) {
        if (String(item.variant_id) === String(ctx.variantId)) {
          cartQty += item.quantity || 0;
        }
      });
    }
    if (seq !== reelUpFormRefreshSeq) return;

    paintReelUpAtc(isPreOrder(variant, cartQty + ctx.qty));
  }

  function bindReelUpUi() {
    if (window.__hvReelUpUiBound) return;
    window.__hvReelUpUiBound = true;

    document.addEventListener(
      'click',
      function (e) {
        if (!e.target || !e.target.closest) return;
        if (
          e.target.closest(
            '.reelUp_variant_item, .reelup_modal_product_form .left_btn, .reelup_modal_product_form .right_btn, .reelUp_modal_cart_btn, .reelUp_popup_cart_action, .reelUp_custom_action.reelUp_modal_shop_now_btn'
          )
        ) {
          setTimeout(function () {
            refreshReelUpProductForm();
            paintReelUpCartMessages(window.__hvPreOrderVariantIds || []);
          }, 300);
        }
      },
      true
    );

    document.addEventListener(
      'input',
      function (e) {
        if (!e.target || !e.target.closest) return;
        if (e.target.closest('.reelup_modal_product_form')) {
          setTimeout(refreshReelUpProductForm, 50);
        }
      },
      true
    );

    var observer = new MutationObserver(
      debounce(function () {
        if (
          document.querySelector('.reelup_modal_product_form') ||
          document.querySelector('.reelUp_popup_cart_product')
        ) {
          refreshReelUpProductForm();
          paintReelUpCartMessages(window.__hvPreOrderVariantIds || []);
        }
      }, 200)
    );
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function rebuildCartForms() {
    try {
      if (!(theme && theme.cart && theme.cart.getCartProductMarkup)) return;
      document.querySelectorAll('form[data-location]').forEach(function (form) {
        var products = form.querySelector('[data-products]');
        if (!products) return;
        theme.cart.getCartProductMarkup().then(function (text) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(text, 'text/html');
          var items = doc.querySelector('.cart__items');
          if (!items) return;
          products.innerHTML = '';
          products.appendChild(items);
          paintCartMessages(
            Array.prototype.slice
              .call(products.querySelectorAll('.cart__item[data-is-preorder="true"]'))
              .map(function (el) {
                return el.getAttribute('data-key');
              })
          );
        });
      });
    } catch (e) {
      /* ignore */
    }
  }

  async function syncCart(options) {
    options = options || {};
    // * A checkout click used to return immediately while another sync was in
    // * flight, then submit the cart with a stale Pre-order property. Wait for
    // * that pass, then sync once more against the cart as it is now.
    if (syncing) {
      if (options.afterCurrent && activeSync) {
        try { await activeSync; } catch (e) { /* the in-flight sync reports its own error */ }
        return syncCart(options);
      }
      return activeSync || { changed: false, preOrderKeys: [] };
    }
    syncing = true;
    variantCache = {};
    activeSync = runSyncCart(options);
    return activeSync;
  }

  async function runSyncCart(options) {

    var preOrderKeys = [];
    var preOrderVariantIds = [];
    var changed = false;

    try {
      var cart = await fetch('/cart.js').then(function (r) {
        return r.json();
      });
      if (!cart || !cart.items || !cart.items.length) {
        window.__hvPreOrderVariantIds = [];
        window.__hvLastCartItems = [];
        paintCartMessages([]);
        paintReelUpCartMessages([]);
        refreshReelUpProductForm();
        return { changed: false, preOrderKeys: [] };
      }

      for (var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i];

        // * Never mark / keep pre-order on donation products; clear if already set
        if (isDonationItem(item)) {
          if (propertiesNeedUpdate(item.properties, false)) {
            await updateLineProperties(
              item.key,
              item.quantity,
              applyPreOrderProperties(item.properties, false)
            );
            changed = true;
          }
          continue;
        }

        var variant = await fetchVariant(item.handle, item.variant_id);
        if (!variant) continue;

        var enable = isPreOrder(variant, item.quantity);
        if (enable) {
          preOrderKeys.push(item.key);
          preOrderVariantIds.push(item.variant_id);
        }

        if (!propertiesNeedUpdate(item.properties, enable)) continue;

        var nextProps = applyPreOrderProperties(item.properties, enable);
        await updateLineProperties(item.key, item.quantity, nextProps);
        changed = true;
      }

      window.__hvPreOrderVariantIds = preOrderVariantIds;
      window.__hvLastCartItems = cart.items;
      paintCartMessages(preOrderKeys);
      paintReelUpCartMessages(preOrderVariantIds);
      refreshReelUpProductForm();

      if (changed && !options.skipRebuild) {
        rebuildCartForms();
      }

      if (changed && options.dispatchEvent !== false) {
        var fresh = await fetch('/cart.js').then(function (r) {
          return r.json();
        });
        document.dispatchEvent(
          new CustomEvent('cart:updated', {
            detail: { cart: fresh, skipPreorderSync: true }
          })
        );
      }

      return { changed: changed, preOrderKeys: preOrderKeys };
    } catch (err) {
      console.error('HVPreorder.syncCart failed', err);
      return { changed: false, preOrderKeys: [] };
    } finally {
      syncing = false;
    }
  }

  async function ensureSyncedBeforeCheckout(event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var checkoutBtn = target.closest('[name="checkout"], .cart__checkout');
    if (!checkoutBtn) return;

    if (checkoutBtn.getAttribute('data-hv-preorder-ready') === '1') {
      checkoutBtn.removeAttribute('data-hv-preorder-ready');
      return;
    }

    var form = checkoutBtn.closest('form');
    if (!form) return;

    event.preventDefault();
    event.stopPropagation();

    checkoutBtn.setAttribute('aria-busy', 'true');
    checkoutBtn.disabled = true;
    try {
      await syncCart({ skipRebuild: true, dispatchEvent: false, afterCurrent: true });
      checkoutBtn.disabled = false;
      checkoutBtn.removeAttribute('aria-busy');
      checkoutBtn.setAttribute('data-hv-preorder-ready', '1');
      checkoutBtn.click();
    } catch (e) {
      checkoutBtn.disabled = false;
      checkoutBtn.removeAttribute('aria-busy');
      console.error(e);
    }
  }

  // * Line-item cart mutations only. /cart/update.js is used by TouchFlow
  // * (and similar) to write cart *attributes* (attribution journey), not
  // * line items. Watching it caused a fetch storm: TouchFlow update.js →
  // * our syncCart → (sometimes) change.js → TouchFlow update.js again,
  // * until Shopify returned 502. Add/change still cover ReelUp ATC.
  var CART_MUTATION_RE = /\/cart\/(add|change)(\.js)?(\?|$)/;

  function isCartMutationUrl(url) {
    if (!url) return false;
    try {
      // Resolve relative URLs (e.g. "/cart/add.js") against location for a
      // consistent pathname check; also handles absolute URLs fine.
      var path = String(url).indexOf('http') === 0
        ? new URL(url).pathname
        : String(url).split('?')[0];
      return CART_MUTATION_RE.test(path) || CART_MUTATION_RE.test(String(url));
    } catch (e) {
      return CART_MUTATION_RE.test(String(url));
    }
  }

  function debounce(fn, wait) {
    var timer = null;
    return function () {
      var args = arguments;
      var ctx = this;
      if (timer) clearTimeout(timer);
      timer = setTimeout(function () {
        timer = null;
        fn.apply(ctx, args);
      }, wait);
    };
  }

  var debouncedSyncAfterExternalMutation = debounce(function () {
    syncCart({ dispatchEvent: false });
  }, 400);

  /**
   * Patch window.fetch and XMLHttpRequest so that ANY cart mutation —
   * regardless of which script triggered it — re-runs the pre-order sync.
   * This closes the gap where third-party apps (e.g. ReelUp's "shop the
   * reel" add-to-cart) call /cart/add.js / /cart/change.js directly via
   * fetch on the main window, bypassing the theme's product-form JS and
   * therefore never firing ajaxProduct:added / cart:updated.
   *
   * Safe to layer with other fetch/XHR patches on this theme (e.g.
   * ultimate-datalayer.liquid) since each wrapper simply calls through to
   * whatever window.fetch / XMLHttpRequest currently is.
   *
   * Re-entrancy: syncCart()'s own updateLineProperties() call also hits
   * /cart/change.js, which would re-trigger this patch — but syncCart()'s
   * `syncing` flag makes any overlapping call a safe no-op.
   */
  function patchCartMutationDetection() {
    if (window.__hvPreorderFetchPatched) return;
    window.__hvPreorderFetchPatched = true;

    var originalFetch = window.fetch;
    if (typeof originalFetch === 'function') {
      window.fetch = function () {
        var requestUrl = (arguments[0] && arguments[0].url) || arguments[0];
        var result = originalFetch.apply(this, arguments);
        if (isCartMutationUrl(requestUrl)) {
          result.then(
            function (response) {
              if (response && response.ok) debouncedSyncAfterExternalMutation();
              return response;
            },
            function (err) {
              return err;
            }
          );
        }
        return result;
      };
    }

    if (typeof window.XMLHttpRequest === 'function') {
      var OriginalXHR = window.XMLHttpRequest;
      window.XMLHttpRequest = function () {
        var xhr = new OriginalXHR();
        var requestUrl = null;
        var originalOpen = xhr.open;
        xhr.open = function (method, url) {
          requestUrl = url;
          return originalOpen.apply(xhr, arguments);
        };
        xhr.addEventListener('load', function () {
          if (
            isCartMutationUrl(requestUrl) &&
            xhr.status >= 200 &&
            xhr.status < 400
          ) {
            debouncedSyncAfterExternalMutation();
          }
        });
        return xhr;
      };
    }
  }

  function bindCartGuards() {
    document.addEventListener(
      'click',
      function (e) {
        ensureSyncedBeforeCheckout(e);
      },
      true
    );

    document.addEventListener('cart:updated', function (evt) {
      if (evt.detail && evt.detail.skipPreorderSync) {
        if (evt.detail.cart && evt.detail.cart.items) {
          var keys = [];
          var variantIds = [];
          evt.detail.cart.items.forEach(function (item) {
            if (hasPreOrderProperty(item.properties)) {
              keys.push(item.key);
              variantIds.push(item.variant_id);
            }
          });
          window.__hvPreOrderVariantIds = variantIds;
          paintCartMessages(keys);
          paintReelUpCartMessages(variantIds);
          refreshReelUpProductForm();
        }
        return;
      }
      syncCart({ dispatchEvent: false });
    });

    document.addEventListener('ajaxProduct:added', function () {
      setTimeout(function () {
        syncCart({ dispatchEvent: false });
      }, 400);
    });

    patchCartMutationDetection();
    bindReelUpUi();

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        syncCart({ dispatchEvent: false });
      });
    } else {
      syncCart({ dispatchEvent: false });
    }
  }

  window.HVPreorder = {
    isPreOrder: isPreOrder,
    isDonationItem: isDonationItem,
    syncCart: syncCart,
    paintCartMessages: paintCartMessages,
    PREORDER_VALUE: PREORDER_VALUE,
    PREORDER_NOTE_VALUE: PREORDER_NOTE_VALUE
  };

  bindCartGuards();
})();
